<div class="history-popup">
  <div class="dialog-header d-flex justify-content-between align-items-center">
    <h2 class="modal-title mb-0">Download Yearly History</h2>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
  </div>

  <div class="dialog-body">
    <p class="popup-hint">
      Public companies in <strong>{{ data.themeName }}</strong>, ranked as of 31 December of each reference year.
      Scores are computed against all companies active in the theme at that date (public and private).
    </p>

    <div class="alert alert-danger d-flex align-items-start gap-2" *ngIf="errorMessage">
      <i class="bi bi-x-circle flex-shrink-0"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="section-label">Reference years</div>
    <div class="preset-buttons">
      <button class="preset-btn" [class.active]="preset === 5" (click)="preset = 5">Last 5 years</button>
      <button class="preset-btn" [class.active]="preset === 10" (click)="preset = 10">Last 10 years</button>
      <button class="preset-btn" [class.active]="preset === 'custom'" (click)="preset = 'custom'">Pick years</button>
    </div>

    <div class="year-chips" *ngIf="preset === 'custom'">
      <button *ngFor="let y of availableYears" class="year-chip" [class.active]="customYears.has(y)"
        (click)="toggleYear(y)">{{ y }}</button>
    </div>

    <label class="latest-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="includeLatest">
      Include latest data <span *ngIf="dateEom">(YTD, {{ dateEom }})</span>
    </label>

    <div class="time-notice">
      <i class="bi bi-hourglass-split"></i>
      <div>
        <strong>Broad themes take time.</strong>
        Each year is recomputed from scratch, which can take up to a minute for broad themes
        (e.g. Batteries, Water).
        <span *ngIf="selectedYears.length">
          For {{ selectedYears.length }} {{ selectedYears.length === 1 ? 'year' : 'years' }}, expect up to
          <strong>~{{ estimateMinutes }} min</strong>.
        </span>
        <div class="time-notice-sub">
          The file is prepared in the background, so you can keep working. Progress shows in the bottom-right corner.
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn btn-secondary-custom" (click)="close()">Cancel</button>
    <button class="btn btn-primary-custom" [disabled]="!selectedYears.length" (click)="download()">
      <i class="bi bi-download"></i>
      Download {{ selectedYears.length ? '(' + selectedYears.length + ')' : '' }}
    </button>
  </div>
</div>
